
export const priceMapper: {[product:string]: string} = {
    GCSub: 'price_1LLBENKA8M9CmmC1l5RAp3n4',
    Alerts: 'price_1LNLxnKA8M9CmmC1mv9u06gr'
}